import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/TTTeenPatti/tableBg.jpg";
import newRoundImg from "../images/TTTeenPatti/New_Round.svg";
import welcome from "../images/TTTeenPatti/welcome.gif";
import ideal from "../images/TTTeenPatti/idle.gif";
import clapping from "../images/TTTeenPatti/clapping.gif";
import crown from "../images/TTTeenPatti/crown.png";
import closedCard from "../images/TTTeenPatti/closed-card.jpg";
import { cards } from "../images/index";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import useRoundLoader from "../../../api/useRoundLoader";
import GameAreaLoader from "../../Loader/GameAreaLoader";

const mapCardStringToAsset = (cardString) => {
  if (!cardString || typeof cardString !== "string") return closedCard;
  const raw = cardString.trim().toUpperCase();
  const suit = raw.slice(-1);
  const rank = raw.slice(0, -1);

  const attempts = [
    `${rank}${suit}`,
    `${rank}${suit}${suit}`,
    `${rank}${suit}.webp`,
    `${rank}${suit}${suit}.webp`,
    raw,
    `${raw}.webp`,
    raw.toLowerCase(),
    `${raw.toLowerCase()}.webp`,
  ];

  for (const key of attempts) {
    if (cards[key]) return cards[key];
  }
  console.warn("Card not found:", cardString, "| tried:", attempts);
  return closedCard;
};

export default function GameScreen({
  bettingClosed,
  socketData,
  onAnimStart,
  onAnimEnd,
}) {
const roundId = socketData?.roundId;
const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);

  const prevBettingClosedRef = React.useRef(false);
  useEffect(() => {
    if (bettingClosed && !prevBettingClosedRef.current) {
      prevBettingClosedRef.current = true;
      onAnimStart?.();
    }
    if (!bettingClosed && prevBettingClosedRef.current) {
      prevBettingClosedRef.current = false;
      onAnimEnd?.();
    }
  }, [bettingClosed, onAnimStart, onAnimEnd]);

  // stage seedha backend flags se
  const stage = !bettingClosed
    ? "welcome"
    : settlement?.clapping
      ? "clapping"
      : "idle";

  const currentGif =
    stage === "welcome" ? welcome : stage === "clapping" ? clapping : ideal;

  // cards sirf tabhi jab bettingClosed true ho, aur jo key aa gayi wahi turant dikhao
  const showCards = stage !== "welcome";
  const playerACard1 = showCards ? settlement?.playerACard1 : null;
  const playerACard2 = showCards ? settlement?.playerACard2 : null;
  const playerACard3 = showCards ? settlement?.playerACard3 : null;
  const playerBCard1 = showCards ? settlement?.playerBCard1 : null;
  const playerBCard2 = showCards ? settlement?.playerBCard2 : null;
  const playerBCard3 = showCards ? settlement?.playerBCard3 : null;

  const getWinnerLabel = () => {
    const outcome = settlement?.outcome;
    if (!outcome) return null;
    if (outcome === "PLAYER_A" || outcome === "PLAYER 1") return "PLAYER A";
    if (outcome === "PLAYER_B" || outcome === "PLAYER 2") return "PLAYER B";
    return outcome;
  };

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className={styles.gameContainer}>
        <div className={styles.mainGameArea}>
          <div className={styles.videoArea}>
            <div className={styles.videoContainer}>
              <img
                src={backgroundImage}
                alt="Teen Patti T20"
                className={styles.backgroundImage}
                draggable={false}
              />

              <div className={styles.gifOverlay}>
                <img
                  src={currentGif}
                  alt={stage + " gif"}
                  className={styles.gifImage}
                  draggable={false}
                  style={{ objectFit: "contain" }}
                />
              </div>

              <div className={styles.cardsContainer}>
                <div className={`${styles.playerSection} ${styles.playerASection}`}>
                  <div className={styles.playerCards}>
                    {[playerACard1, playerACard2, playerACard3].map((card, index) => (
                      <div key={`playerA-${index}`} className={styles.cardWrapper}>
                        <img
                          src={card ? mapCardStringToAsset(card) : closedCard}
                          alt={`PlayerA-Card${index + 1}`}
                          className={styles.cardImage}
                          draggable={false}
                        />
                      </div>
                    ))}
                  </div>
                  <span className={styles.playerLabel} style={{ marginTop: "-1px" }}>PLAYER A</span>
                </div>

                <div className={styles.divider}></div>

                <div className={`${styles.playerSection} ${styles.playerBSection}`}>
                  <div className={styles.playerCards}>
                    {[playerBCard1, playerBCard2, playerBCard3].map((card, index) => (
                      <div key={`playerB-${index}`} className={styles.cardWrapper}>
                        <img
                          src={card ? mapCardStringToAsset(card) : closedCard}
                          alt={`PlayerB-Card${index + 1}`}
                          className={styles.cardImage}
                          draggable={false}
                        />
                      </div>
                    ))}
                  </div>
                  <span className={styles.playerLabel} style={{ marginTop: "-1px" }}>PLAYER B</span>
                </div>

                {stage === "clapping" && getWinnerLabel() && (
                  <div className={styles.winnerAnimation}>
                    <img src={crown} alt="Crown" className={styles.crownImage} />
                    <span className={styles.winnerText}>
                      WINNER: {getWinnerLabel()}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
      </div>
    </GameAreaLoader>
  );
}